export default "__VITE_PUBLIC_ASSET__8f0a9c79__"